import { rem } from 'polished';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Audio } from 'icons';

import SegmentActionButton from './SegmentActionButton';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Icon = styled<any>(Audio).attrs(({ theme }) => ({
  primaryColor: theme.colors.primary,
}))`
  width: ${rem('92px')};
  height: ${rem('92px')};
  margin-bottom: -10px;
  *[stroke] {
    stroke-width: 0.7;
  }
`;

const ListenButton = () => {
  const { t: translate } = useTranslation('courses');

  return (
    <SegmentActionButton text={translate('segment.listen_button.text')}>
      <Icon />
    </SegmentActionButton>
  );
};

export default ListenButton;
